import {createSupplierOffer} from "@project/sdk/engineering";
import {CreateSupplierOfferResponse} from "@project/sdk/engineering/zod";
import {mutationOptions} from "@tanstack/react-query";

import {supplierOfferKeys, supplierOfferMutationKeys} from "../../../supplierOffer-keys";
import type {CreateSupplierOfferFormPayload} from "./create-supplier-offer.schema";

export function createSupplierOfferMutationOptions() {
  return mutationOptions({
    mutationKey: supplierOfferMutationKeys.createSupplierOffer,
    mutationFn: async (payload: CreateSupplierOfferFormPayload) => {
      const args: Parameters<typeof createSupplierOffer> = [payload];
      return CreateSupplierOfferResponse.parse(await createSupplierOffer(...args));
    },
    onSuccess: async (identity, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierOfferKeys.lists()}),
        client.invalidateQueries({queryKey: supplierOfferKeys.detail(identity)}),
      ]);
    },
  });
}
